export function pushSse(buffer, chunk, onEvent) {
    const blocks = (buffer + chunk).split('\n\n');
    const rest = blocks.pop() ?? '';
    blocks.forEach((block) => {
        const event = parseBlock(block);
        if (event) {
            onEvent(event);
        }
    });
    return rest;
}

function parseBlock(block) {
    let name = 'message';
    const dataLines = [];
    block.split(/\r?\n/).forEach((line) => {
        if (line.startsWith('event:')) {
            name = line.slice(6).trim();
        } else if (line.startsWith('data:')) {
            dataLines.push(line.slice(5).trim());
        }
    });
    if (!dataLines.length) {
        return null;
    }
    return { event: name, data: JSON.parse(dataLines.join('\n')) };
}
